import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LocationsConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="100%" height={20} />

      <Styles.LocationsList>
        {Array.from({ length: 5 }).map((_, index) => (
          <Styles.LocationRow key={index}>
            <Skeleton variant="circular" width={32} height={32} />
            <Styles.LocationInfo>
              <Skeleton variant="text" width={240} height={20} />
              <Skeleton variant="text" width="60%" height={16} />
            </Styles.LocationInfo>
            <Styles.ChipsRow>
              <Skeleton variant="rounded" width={120} height={24} />
              <Skeleton variant="rounded" width={140} height={24} />
            </Styles.ChipsRow>
            <Skeleton variant="circular" width={24} height={24} />
          </Styles.LocationRow>
        ))}
      </Styles.LocationsList>

      <Styles.ActionsContainer>
        <Skeleton variant="rounded" width={220} height={40} />
        <Skeleton variant="rounded" width={240} height={32} />
      </Styles.ActionsContainer>
    </Styles.Container>
  )
}

export default LocationsConfigurationSkeleton
